<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <button @click="telecharger" v-if="valideEtape3" :disabled="isLoading"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          <span v-if="!isLoading">Exporter</span>
          <span v-else>
            <span class="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true"></span>
            Export en cours...
          </span>
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
        <div class="form-group mb-15 mb-sm-20 mb-md-25">
          <label class="d-block text-black fw-semibold mb-10"> Mot clé </label>
          <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
            class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
          <ErrorMessage name="mot" class="text-danger" />
        </div>
      </div>
      <div class="d-sm-flex align-items-center" v-if="checkParentPermission(['MettreAJourEmplacement','CreationEmplacement'])">
        <router-link
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          to="/ajouter-emplacement">
          <i class="fa fa-plus-circle"></i>
          Ajouter un emplacement
        </router-link>

      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
      </div>
      <hr />
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                A code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                N Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Locataire
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Exploitant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Secteur
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Activité
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Parent Emplacement
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Détail
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(us, index) in usagers" :key="index" >
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : ''">
                {{ us.codeemp }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : ''">
                {{ us.ncode_emp }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : ''">
                {{ us.contrats.length > 0 ? us.contrats[0].locataire : us.nomLocataire }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ us.contrats.length > 0 ? us.contrats[0].usagers : us.nomExploitant }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ us?.secteur?.libelle_secteur }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ afficher20Caracteres(us?.activite?.activite_nom) }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ afficher20Caracteres(us?.emplacementParent?.ncode_emp) }}
              </td>
              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ afficher20Caracteres(us?.nouveau_activite) }}
              </td>

              <td class="shadow-none lh-1 fw-medium" :class="us.estFils == true ? 'text-danger' : 'text-black-emphasis'">
                {{ separateur(us.montant_location) }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-end pe-0 sm">
                <div class="dropdown">
                  <span class="badge text-white bg-secondary fs-15 dropdown-toggle" data-bs-toggle="dropdown"
                    aria-expanded="false">
                    Actions
                    <i class="flaticon-chevron-2 position-relative ms-5 top-2 fs-15"></i>
                  </span>
                  <ul class="dropdown-menu">
                    <li>
                      <a href="#" class="dropdown-item d-flex align-items-center" data-bs-toggle="modal"
                        data-bs-target="#UpEmplacementModal" @click="modifUsager(us.codeemp)" type="button"><i
                          class="flaticon-view lh-1 me-8 position-relative top-1"></i>
                        Modifier
                      </a>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                      <router-link :to="{ name: 'ViewEmplacementPage', params: { id: us.codeemp } }">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Détails
                      </router-link>
                    </li>
                    <li class="dropdown-item d-flex align-items-center">
                      <a @click="desactiverEmplacement(us.codeemp)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        Supprimer place
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
  <UpEmplacementModal :item="selectedItem" @close="recharger" @open="show_Modal" />
</template>
<script lang="ts">
import { ref, defineComponent, onMounted, watch } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import UpEmplacementModal from "./Emplacement.vue";
import {
  showModal,
  suppression,
  separateur,
  format_Date,
  format_date,
  supprimerElement,
  error,
  dateActuelle,
  success,
  getUrlApiForFiles,
  afficher20Caracteres,
  downloadExcel,
} from "@/utils/utils";
import { Contrat } from "@/models/Contrat";
import ApiService from "@/services/ApiService";
import { Option } from "@/models/Option";
import PaginationComponent from "@/components/Utilities/Pagination.vue";
import JwtService from "@/services/JwtService";
import axios from "axios";
import Swal from "sweetalert2";

export default defineComponent({
  name: "ListeEmplacement",
  components: {
    PaginationComponent,
    Field,
    ErrorMessage,
    UpEmplacementModal,
  },
  setup: () => {
    // BEGIN PAGINATE
    const searchTerm = ref("");
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const secteursOptions = ref<Array<Option>>([]);
    const motCle = ref("");
    const dateFin = ref(dateActuelle());
    const dateDebut = ref(dateActuelle());
    const lemontant = ref("0");
    const donn = ref();
    const selectedItem = ref();

    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const ajouterUsager = () => {
      selectedItem.value = null;
    };

    const modifUsager = (usager) => {
      selectedItem.value = usager;
    };
    // END PAGINATE
    const handlePaginate = ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        actionRecherche(page_, limit_);
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const valideEtape3 = ref(true);
    const isLoading = ref(false);
    const recharger = () => {
      actionRecherche(page.value, limit.value);
    };
    const agent = ref();
    const agentOptions = ref();
    const usagers: any = ref<Array<any>>([]);

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any, dossier = "Recu") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }
    const actionRecherche = async (page = 1, limi = 10, searchTerm = "") => {
      const element = {
        motCle: motCle.value,
        page: page,
        totalPages: totalPages.value,
        limit: limi,
        totalElements: totalElements.value,
        mot: searchTerm,
      };
      donn.value = element;
      try {
        const response = await axios.post("/listeEmplacement", element);
        usagers.value = response.data.data.data.entities;
        totalPages.value = response.data.data.totalPages;
        limit.value = response.data.data.limit;
        totalElements.value = response.data.data.totalElements;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const getPoint = async () => {
      try {
        valideEtape3.value = false;
        donn.value = {
          dateDebut:
            (dateDebut.value ? dateDebut.value : dateActuelle()) + " 00:00:00",
          dateFin:
            (dateFin.value ? dateFin.value : dateActuelle()) + " 23:59:59",
          motCle: motCle.value,
          acteur: agent.value,
        };
        const response = await axios.post("/getPoint", donn.value);
        openNewWindow({ reference: response.data.data }, "Point");
        valideEtape3.value = true;
      } catch (error) {
        // error("Erreur");
      }
    };
    const desactiverEmplacement = async (codeemp) => {
      try{
        Swal.fire({
          text: `Vous êtes sur le point de supprimer l'emplacement ayant pour code ${codeemp}. Etes-vous sûr ?`,
          icon: "warning",
          buttonsStyling: true,
          showCancelButton: true,
          confirmButtonText: "Supprimer",
          cancelButtonText: `Annuler`,
          heightAuto: false,
          customClass: {
            confirmButton: "btn btn-danger",
          },
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const response = await axios.put("/emplacement/status/"+codeemp, { codeemp });
            if (response.data.code == 200) {
              success(response.data.message);
              await actionRecherche(1, 10);
            }
          }
        })
        .catch(async ({ response }) => {
          error(response.message);
        });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
      }
    };

    const telecharger = async () => {
      valideEtape3.value = false;
      isLoading.value = true;
      try {
        const element = {
          motCle: motCle.value,
        };
        const response = await axios.post("/liste/emplacements/export", element);
        const downloadUrl = await getUrlApiForFiles("Excel", response.data.data + ".xlsx");

        await downloadExcel(downloadUrl);
        openAndPrint(getUrlApiForFiles("Excel", response.data.data + ".xlsx"));
        valideEtape3.value = true;
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message || err.message);
        } else {
          if (err instanceof Error) {
            error(err.message);
          } else {
            error(String(err));
          }
        }
        valideEtape3.value = true;
      } finally {
        isLoading.value = false;
      }
    };

    watch(motCle, (newValue, oldValue) => {
      page.value = 1;
      limit.value = 10;
      totalPages.value = 0;
      totalElements.value = 0;
      motCle.value = newValue;
      actionRecherche(page.value, limit.value);
    });
    const supprime = async (id) => {
      Swal.fire({
        text: `Vous êtes sur le point de supprimer le retour n° ${id}. Etes-vous sûr ?`,
        icon: "warning",
        buttonsStyling: true,
        showCancelButton: true,
        confirmButtonText: "Supprimer",
        cancelButtonText: `Annuler`,
        heightAuto: false,
        customClass: {
          confirmButton: "btn btn-danger",
        },
      })
        .then(async (result) => {
          if (result.isConfirmed) {
            await ApiService.delete(`delete/usager/${id}`)
              .then(async ({ data }) => {
                if (data.code == 200) {
                  success(data.message);
                  await actionRecherche(1, 10);
                }
              })
              .catch(async ({ response }) => {
                error(response.message);
              });
          }
        })
        .catch(async ({ response }) => {
          error(response.message);
        });
    };
    const privileges = ref<Array<string>>(JwtService.getPrivilege());

    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }

    const checkParentPermission = (permissions) => {
      for (const permission of permissions) {
        if (checkPermission(permission)) {
          return true; 
        }
      }
      return false; 
    }
    onMounted(async () => {
      await actionRecherche(1, 10);
    });
    return {
      dateDebut,
      dateFin,
      checkParentPermission,
      suppression,
      recharger,
      page,
      agentOptions,
      agent,
      openNewWindow,
      usagers,
      secteursOptions,
      totalPages,
      limit,
      format_date,
      format_Date,
      separateur,
      totalElements,
      handlePaginate,
      searchTerm,
      motCle,
      error,
      lemontant,
      getPoint,
      valideEtape3,
      isLoading,
      selectedItem,
      afficher20Caracteres,
      show_Modal,
      ajouterUsager,
      modifUsager,
      dateActuelle,
      supprime,
      desactiverEmplacement,
      telecharger
    };
  },
});
</script>